import HeaderButtons from "../header-buttons/HeaderButtons.tsx";
import LanguageSelector from "../language-selector/LanguageSelector.tsx";
import {RefObject, useEffect, useState} from "react";
import {isRouteExist} from "../../../helpers/routes/routesHelper.ts";
import * as routes from "../../../../routes.json"

const ButtonsSection = ({menuContainerRef}: {menuContainerRef: RefObject<HTMLDivElement> }) => {
    const [isRouteValid, setIsRouteValid] = useState<boolean>(false);

    useEffect(() => {
        setIsRouteValid(isRouteExist(routes, location.pathname.substring(1)));
    }, [location.pathname]);

    return (
        <>
            <ul className="navbar-nav ms-auto">
                <HeaderButtons menuContainerRef={menuContainerRef} />
                {isRouteValid && <LanguageSelector />}
            </ul>
        </>
    )
}

export default ButtonsSection;
